import { HStack, Icon } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

export const Wrapper = HStack.withConfig({
  alignItems: 'center',
  marginBottom: '$1',
});

export const Message = withTypography({
  fontSize: 'xs',
  color: getDesignToken('text-default'),
  style: { marginLeft: 1.5, textTransform: 'capitalize' },
});

export const MessageIcon = Icon.withConfig({
  color: getDesignToken('text-default'),
});
